export default __webpack_public_path__ + "static/media/clientslist-icon.afe23a19.svg";